import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { CreateMemoryGameProcessedContentExampleTemplate } from '../../components/Templates';

import { QuickCreateGameMode } from '../../models/DraftStore';
import { useDraftStore } from '../../stores/DraftStore';

interface State {
  createType: QuickCreateGameMode | undefined;
}

const CreateMemoryGameProcessedContentExampleScreen: React.FC = () => {
  const navigate = useNavigate();
  const [state, setState] = useState<State>({
    createType: undefined,
  });

  const { mode } = useDraftStore((store) => {
    const _mode = store.getGameMode();

    return { mode: _mode };
  });

  useEffect(() => {
    if (mode) {
      setState((s) => ({ ...s, createType: mode }));
    } else {
      navigate('/create/memory-game/select-type', { replace: true });
    }
  }, [mode, navigate]);

  const onClickBack = useCallback(() => {
    navigate('/create/memory-game/input-content', { replace: true });
  }, [navigate]);

  const gameContents = useMemo(() => {
    return [
      'strawberry\nrestaurant\ntransportation',
      'The weather today is good. Let’s go to the beach and swim. We will bring some pizza and soft drinks.',
    ];
  }, []);

  return (
    <CreateMemoryGameProcessedContentExampleTemplate
      type={state.createType}
      gameContents={gameContents}
      onClickBack={onClickBack}
    />
  );
};
export default CreateMemoryGameProcessedContentExampleScreen;
